import axios from 'axios'
import MiniSearch from 'minisearch'
import moment from 'moment'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/rssFeed";
const store = {};
const mutations = {
    SET_RSS_FEED_LIST(state, posts) {
        state.rssFeedList = posts;
        state.rssFeedListIsLoading = false;
    },
    SET_RSS_DETAIL(state, posts) {
        state.rssDetail = posts.data;
        state.rssDetailChanged = false;
    },
    SET_RSS_FEED_ENTRIES(state, posts) {
        var start = new Date();
        console.log("START COMMITING for " + state.rssId, moment(new Date()).diff(this.startTime) + 'ms');
        state.rssFeedEntryListIsLoading = true;
        if (!posts.success) {
            alert("An error occured while fetching rss entries:" + posts.errorMessage);
            state.miniSearch.removeAll();
            console.log("FINISHED COMMITING for " + state.rssId, moment(new Date()).diff(start) + 'ms*');
            return;
        }
        posts.data.forEach(d => {
            d.score = 1;
        });
        state.rssFeedEntryList = posts.data;
        if (posts.filter) {
            var filter = JSON.parse(posts.filter);
            state.filteredValues = filter.filteredValues;
            state.searchFilter = filter.searchFilter;
            state.searchText = filter.searchFilter;
            state.rfeId = filter.rfeId;
            state.rssId = filter.rssId;
            state.lang = filter.lang ? filter.lang : state.lang;
        }
        state.rssId = posts.rssId;
        console.log("START LOADING MINISEARCH for " + state.rssId, moment(new Date()).diff(start) + 'ms*');
        state.miniSearch.removeAll();
        const filterData = posts.data.map((d) => {
            return {
                title: d.EntryTitle,
                description: d.EntryDescription,
                keyWords: d.EntryKeyWords,
                id: d.RfeId
            };
        });
        state.miniSearch.addAll(filterData);
        console.log("FINISHED LOADING MINISEARCH for " + state.rssId, moment(new Date()).diff(start) + 'ms*');
        state.refreshFilter = true;
        state.rssFeedEntryListIsLoading = false;
        console.log("FINISHED COMMITING for " + state.rssId, moment(new Date()).diff(start) + 'ms*');
    },
    SET_HIDE_ENTRY(state, data) {
        data.EntryHidden = true;
    },
    SET_RSSID(state, rssId) {
        state.rssId = rssId;
    },
    SET_RFEID(state, rfeId) {
        state.rfeId = rfeId;
    },
    SET_TOPIC_RSS_INFO(state, data) {
        data.record.EntryImportInfos = data.res.list;
    },
    SAVE_FILTER(state, data) {
        console.log(data);
    },
    SAVE_RSS_ENTRY(state) {
        state.rssFeedUpdated = true;
        state.rssDetailChanged = false;
    },
    ADD_RSS_FEED(state) {
        state.rssFeedListIsLoading = false;
    },
};
const state = {
    rssDetail: {},
    rssDetailChanged: false,
    rssFeedUpdated: false,
    rssFeedEntryListIsLoading: false,
    rssFeedListIsLoading: false,
    rssFeedList: [],
    rssFeedEntryList: [],
    filteredValues: [],
    lang: 'de',
    languages: [{ name: 'german', id: 'de' }, { name: 'english', id: 'en' }],
    searchFilter: "",
    searchText: "",
    startTime: new Date(),
    rssId: -1,
    fetchedRssId: -2,
    rfeId: 0,
    refreshFilter: false,
    miniSearch: new MiniSearch({
        fields: ['title', 'description'],
        searchOptions: {
            boost: { title: 2, description: 1 },
            fuzzy: 0.2,
            prefix: true,
        }
        //idField: 'RfeId',
        //processTerm: (term) => term.toLowerCase()
    })
};
const getters = {};
const actions = {
    getRssDetail({ commit }, data) {
        commit('loadingStatus', true);
        var formData = new FormData();
        formData.append("rssId", data.rssId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                commit('SET_RSS_DETAIL', res.data);
            });
    },
    getRssFeedList({ commit }) {
        if (state.fetchedRssId != state.RssId) {
            state.fetchedRssId = state.RssId;
            var start = new Date();
            console.log("getRssFeedList START FETCHING", moment(new Date()).diff(state.startTime) + 'ms');
            state.rssFeedListIsLoading = true;
            axios
                .get(baseUri + '/GetList')
                .then(res => {
                    console.log("getRssFeedList FINISHED FETCHING", moment(new Date()).diff(state.startTime) + 'ms', moment(new Date()).diff(start) + 'ms*');
                    commit('SET_RSS_FEED_LIST', res.data.data);
                });
        }
    },
    hideEntry({ commit }, data) {
        var formData = new FormData();
        formData.append("rfeIdList", [data.RfeId]);
        axios
            .post(baseUri + '/HideEntry', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_HIDE_ENTRY', data);
                }
            });
    },
    getRssEntryList({ commit }, { rssId, litId, lang } ) {
        var start = new Date();
        console.log("getRssEntryList START FETCHING for " + rssId, moment(new Date()).diff(state.startTime) + 'ms');
        state.rssFeedEntryListIsLoading = true;
        state.RssId = rssId;
        const params = {
            rssId: rssId,
            litId: litId,
            lang: lang,
            refresh: true
        };
        axios
            .get(baseUri + '/GetEntries', { params })
            .then(res => {
                console.log("getRssEntryLists FINISHED FETCHING for " + rssId, moment(new Date()).diff(state.startTime) + 'ms', moment(new Date()).diff(start) + 'ms*');
                commit('SET_RSS_FEED_ENTRIES', res.data);
            });
    },
    loadEntryImportInfo({ commit }, record) {
        const params = {
            rfeId: record.RfeId
        };
        axios
            .get(baseUri + '/GetTopicRssInfo', { params })
            .then(res => {
                commit('SET_TOPIC_RSS_INFO', { record, res: res.data });
            });
    },
    addRssFeed({ commit, dispatch }, record) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(record));
        axios
            .post(baseUri + '/CreateNew', formData)
            .then(res => {
                dispatch("getRssFeedList");
                commit('ADD_RSS_FEED', { commit, dispatch }, { record, res: res.data });
                commit('SET_RSSID', res.data.RssId);
            });
    },
    saveFilter({ commit }, filter) {
        var formData = new FormData();
        formData.append("filter", JSON.stringify(filter));
        axios
            .post(baseUri + '/SaveFilter', formData)
            .then(res => {
                if (res.success == true) {
                    commit('SAVE_FILTER', { filter });
                }
            });
    },
    saveRssEntry({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.rssDetail));
        axios
            .post(baseUri + '/SaveRssEntry', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_RSS_ENTRY');
                } else {
                    alert("An error occured while updating rss feed: " + res.data.errorMessage);
                }
            });
    },
    resetStartTime() {
        state.startTime = new Date();
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}